import React from 'react';
import './Button.css';

/**
 * LinkButton Component
 * Button styled as a link for text-based actions
 * 
 * @param {function} onClick - Click handler
 * @param {ReactNode} children - Button content
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 */
const LinkButton = ({ 
  onClick, 
  children, 
  disabled = false, 
  className = '' 
}) => {
  return (
    <button
      className={`btn btn-text link-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default LinkButton;

